"use client";

import Link from "next/link";
import { ComponentProps, useCallback } from "react";
import { useBackUrl } from "@erp/shared-libs/hooks";
import { IRoute } from "@erp/shared-libs/utils";

// =======================================================
// Props
// =======================================================
interface LinkWithBackUrlProps extends ComponentProps<typeof Link> {
  href: string;
  route: IRoute;
  anchorKey?: string | number;
  replaceBackUrl?: boolean;
}

// =======================================================
// Component
// =======================================================
export function LinkWithBackUrl({
  href,
  route,
  anchorKey,
  replaceBackUrl,
  ...props
}: LinkWithBackUrlProps) {
  const { combineBackUrl, combineAnchorKey } = useBackUrl(route);

  const handleInsertAnchorBeforeNavigate = useCallback(() => {
    const replaceUrl = combineAnchorKey(window.location.href, anchorKey);
    window.history.replaceState({}, "", replaceUrl);
  }, [anchorKey, combineAnchorKey]);

  return (
    <Link
      href={combineBackUrl(href, anchorKey, replaceBackUrl)}
      onNavigate={handleInsertAnchorBeforeNavigate}
      prefetch={false}
      {...props}
    />
  );
}
